import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { PagoService } from '../../../services/pago.service';
import { UserService } from '../../../services/user.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { concatMap, finalize, from, take, toArray } from 'rxjs';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Cell, DinamicData } from 'src/app/models/dinamic-data';
import { Methods } from 'src/app/shared/methods';
import { ConfigService } from '../../../services/config.service';
import { ChatLogService } from "../../../services/chatlog.service";

interface Check {
  payableTo: string | null;
  amount: number | null;
}

@Component({
  selector: 'app-editpayment',
  templateUrl: './editpayment.component.html',
  styleUrls: ['./editpayment.component.css'],
  providers: [UserService, PagoService,ChatLogService]
})
export class EditpaymentComponent implements OnInit {
  poOptions = [
    { value: 'PO',          name: 'Purchase Order' },
    { value: 'CONSIGNMENT', name: 'Consignment' }
  ];
  public poNumbers: string[] = [];
  companyOptions = [];   
  public paymentdata: any = {};
  token: string;
  public loadingmodal = true;
  checks: Check[] = [];
  history: any[] = [];
  selectedPaymentType: string | null = null;
  public mtds: Methods = new Methods();
  public options: Array<any> = [];
  public loading = false;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public config: Array<any> = [];
  public podata: DinamicData = new DinamicData(
    ['check','ID','PO', 'Vendor', 'Rep', 'Amount', 'Purchasing Terms','Manifest Status','Testing Status','Purchase Date']
  )
  public shippingMethods: string[] = [
    'USPS (no tracking)',
    'UPS Ground',
    'UPS Next Day Air Saver',
    'UPS Next Day Air',
    'UPS Next Day Early'
  ];
  public notesType = 'PAYMENT';
  public PaymentID;
  public bulk: string[] = [];
  selectedCompany:    string | null = null;
  public today: Date;
  public sinceDate: any = null;
  public toDate;
  dataSource: Array<{ po: string; amount: number }> = [];

  public WTDOME: 'manual' | 'file' = 'manual';
  public WTINT: 'manual' | 'file' = 'manual';
  public ACHDOME: 'manual' | 'file' = 'manual';


/*  */
  public bulkDetails: Array<{ id: number; po: string; amount: number }> = [];
  public bulkTotal: string = "0.00";
  public equipmentReceivedComment: string = '';
  public loadingComment: boolean = false;
  public testedComment: string = '';
  public notecomment: string = '';
/*  */
  step2Control: FormGroup;
  step3Control: FormGroup;
  originalReceived = ''; // 'yes' o 'no'
originalReceivedComment = '';
originalTested = ''; // 'yes' o 'no'
originalTestedComment = '';
originalNoteComment = '';
  constructor(
    private fb: FormBuilder,private _config: ConfigService,  private _chatLogService: ChatLogService,
    private _pagoService: PagoService, 
    private _userService: UserService,   private dialog: MatDialog,   private dialogRef: MatDialogRef<EditpaymentComponent>,  @Inject(MAT_DIALOG_DATA) public data: { id: number }
  ) {
    this.token = this._userService.getToken();
    this.step2Control = this.fb.group({
      received: [null]
    });
    this.step3Control = this.fb.group({
      tested: [null]
    });
  }

  ngOnInit() {
    this.getlistvendor(); 

    this.getdatapayment(this.data.id);

    this._config.getConfig('popaymentTableEdit').subscribe(
      r => {
        if (r.data) {
          this.options = JSON.parse(r.data.data);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          this.options = this.mtds.colopt(this.podata.headers, []);
        }
   
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    /*  */
    if (this.paymentdata.equipmentReceived) {
      this.step2Control.get('received').setValue(
        this.paymentdata.equipmentReceived.toLowerCase()
      );
    }
    if (this.paymentdata.equipmentTested) {
      this.step3Control.get('tested').setValue(this.paymentdata.equipmentTested.toLowerCase());
    }
    /*  */

  }
  
  private getdatapayment(id: number): void {
    this.loadingmodal = true;
    this._pagoService
      .getpaymentbyid(this.token, { id })
      .pipe(
        take(1),
        finalize(() => (this.loadingmodal = false))
      )
      .subscribe({
        next: ({ status, data }) => {
          if (status === 'success') {
            this.paymentdata = data;

            this.PaymentID = data.id;
            
            if (data.paymentType === 'PO') {
           
              const firstItem = data.items?.[0];
              this.selectedCompany = firstItem?.processingInstruction?.clientName || null;
          
              this.bulk = data.items.map(i => i.processingInstruction?.id).filter(id => id != null).map(id => id.toString());
              this.poNumbers = data.items.map(item => item.poInfo?.po).filter(Boolean);
              this.setBulkDetails();
            } else if (data.paymentType === 'CONSIGNMENT') {
              this.selectedCompany = data.CosigmentDetail?.clientname || null;
        
              this.sinceDate = data.CosigmentDetail?.datefrom ? new Date(data.CosigmentDetail.datefrom.timestamp * 1000) : null;
              this.toDate = data.CosigmentDetail?.dateto ? new Date(data.CosigmentDetail.dateto.timestamp * 1000) : null;
              if (!data.requestedAmount) {
                data.requestedAmount = data.totalAmount;
              }
            }

            if (data.methodDetail && data.methodDetail.pickupDatetime) {
              
              if (typeof data.methodDetail.pickupDatetime === 'string') {
                data.methodDetail.pickupDatetime = new Date(data.methodDetail.pickupDatetime);
              }
            }
            if (data.methodDetail && data.methodDetail.methodType) {
              this.selectedPaymentMethod = data.methodDetail.methodType;
            } else {
              this.selectedPaymentMethod = 'CHECK_PICKUP';
            }
            if (!data.methodDetail) {
              data.methodDetail = { numberOfChecks: 1 }; 
            }

            if (data.equipmentReceived && data.equipmentReceived.toUpperCase() === 'NO') {
              this.getComment(data.id,2);
            }
            if (data.equipmentTested && data.equipmentTested.toUpperCase() === 'NO') {
              this.getCommentstep3(data.id,3);
            }
            if (data.paymentType === 'PO') {
             
              if (data.equipmentReceived) {
                this.step2Control.get('received').setValue(data.equipmentReceived.toLowerCase()); // "yes" o "no"
              }
              if (data.equipmentTested) {
                this.step3Control.get('tested').setValue(data.equipmentTested.toLowerCase());
              }
            }
            if (data.methodDetail?.modeform === 0) {
              this.WTDOME = 'file';
              this.WTINT = 'file';
              this.ACHDOME = 'file';
            } else {
             
              this.WTDOME = 'manual';
              this.WTINT = 'manual';
              this.ACHDOME = 'manual';
            }
            if (data.paymentDueType === 'SpecificDate' && data.paymentDueDate) {
            
              if (typeof data.paymentDueDate === 'string') {
                data.paymentDueDate = new Date(data.paymentDueDate + 'T12:00:00');
              }
            }
            this.getCommentstep5(data.id,5);
            this.buildChecks(this.paymentdata.methodDetail);
            this.getlistpo();


            this.originalReceived = this.paymentdata.equipmentReceived?.toLowerCase() || '';
           
            this.originalTested = this.paymentdata.equipmentTested?.toLowerCase() || '';
       
        
          }
        },
        error: (err) => console.error('Error al obtener pago', err)
      });
  }
  saving = false;
  submitting = false;
  

  /*  */
  submitEdit(): void {
    if (this.submitting) return;
    this.submitting = true;
  
    const isPO = this.paymentdata.paymentType === 'PO' || this.paymentdata.paymentType === 'PO'.toUpperCase();
    const vendorId           =  1; 
 
if (
  this.paymentdata.paymentType === 'CONSIGNMENT' &&
  (
    this.paymentdata.totalAmount === undefined ||
    this.paymentdata.totalAmount === null ||
    Number(this.paymentdata.totalAmount) === 0
  )
) {
  this.paymentdata.totalAmount = this.paymentdata.requestedAmount;
}
const selectedTabIdx = this.getSelectedMethodTabIndex();
const actualMethodType = this.methodTabs[selectedTabIdx] || 'CHECK_PICKUP';
this.paymentdata.methodDetail.methodType = actualMethodType;
    
    const payload: any = {
      id: this.paymentdata.id,
      vendorId: vendorId,
      paymentType: this.paymentdata.paymentType, 
      status: this.paymentdata.status,
      wizardStep: this.paymentdata.wizardStep,
      requestedAmount: this.paymentdata.requestedAmount,
      totalAmount: this.paymentdata.totalAmount,
      paymentDueType: this.paymentdata.paymentDueType,
      methodDetail: { ...this.paymentdata.methodDetail },
      historyNote: this.notecomment 
    };
    
    if (payload.methodDetail?.pickupDatetime) {
      payload.methodDetail.pickupDatetime = this.formatDateForPayload(payload.methodDetail.pickupDatetime);
    }
  
    if (payload.paymentDueType === 'SpecificDate' && this.paymentdata.paymentDueDate) {
      payload.paymentDueDate = this.paymentdata.paymentDueDate instanceof Date
        ? this.paymentdata.paymentDueDate.toISOString().split('T')[0]
        : this.paymentdata.paymentDueDate;
    }
  
    if (isPO) {
      // SOLO PARA PO:
      payload.items = this.bulkDetails.map(item => ({
        processingInstructionId: item.id,
        requestedAmount: item.amount
      }));
      
      payload.equipmentReceived = this.step2Control.get('received').value 
      ? (this.step2Control.get('received').value === 'yes' ? 'YES' : 'NO') 
      : this.paymentdata.equipmentReceived;
    payload.equipmentTested = this.step3Control.get('tested').value 
      ? (this.step3Control.get('tested').value === 'yes' ? 'YES' : 'NO') 
      : this.paymentdata.equipmentTested;
    } else if (this.paymentdata.paymentType === 'CONSIGNMENT' || this.paymentdata.paymentType === 'Consignment') {
      // SOLO PARA CONSIGNMENT:
      
      payload.consignmentDetail = {
        dateFrom: this.formatDateForPayload(this.sinceDate),
        dateTo: this.formatDateForPayload(this.toDate),
        fileGroupId: this.paymentdata.consignmentDetail?.fileGroupId ?? null,
        ClientName: this.selectedCompany
      };
      
      delete payload.items;
      delete payload.equipmentReceived;
      delete payload.equipmentTested;
    }
  
    
    if (payload.paymentDueType !== 'SpecificDate') {
      delete payload.paymentDueDate;
    }
  
    const cleanNote = (msg: string) => {
      const p = msg.split('–');
      if (p.length >= 2 && p[0].trim().toLowerCase().includes('additional notes')) {
        return p.slice(1).join('–').trim();
      }
      return msg ? msg.trim() : '';
    };


    const receivedNow = this.step2Control.get('received').value; // 'yes' o 'no'
    const receivedCommentNow = (this.equipmentReceivedComment || '').trim();
  
    const testedNow = this.step3Control.get('tested').value;
    const testedCommentNow = (this.testedComment || '').trim();
  
    let  noteNow = (this.notecomment || '').trim();
    const notePrefix = 'EDIT - Additional Notes – ';
    if (noteNow.startsWith(notePrefix)) {
      noteNow = noteNow.substring(notePrefix.length).trim();
    }
    const originalNote = cleanNote(this.originalNoteComment || '');
     const currentNote = cleanNote(noteNow);
    let changedEtapa2 = false;
    if (receivedNow !== this.originalReceived) {
      changedEtapa2 = true;
    } else if (receivedNow === 'no' && receivedCommentNow !== this.originalReceivedComment) {
      changedEtapa2 = true;
    }
  
    let changedEtapa3 = false;
    if (testedNow !== this.originalTested) {
      changedEtapa3 = true;
    } else if (testedNow === 'no' && testedCommentNow !== this.originalTestedComment) {
      changedEtapa3 = true;
    }
  
    let changedNote = (currentNote !== originalNote);

    const paymentId = this.paymentdata.id;
    const fatherId = `payment-${paymentId}`;
    const calls = [];
  
    // ETAPA 2

  
    // ETAPA 3
    if(this.paymentdata.paymentType === 'PO' ){

      if (changedEtapa2) {
        let msg2 = `EDIT - Has the equipment been received? – ${receivedNow?.toUpperCase()}`;
        if (receivedNow === 'no' && receivedCommentNow) {
          msg2 += ` – ${receivedCommentNow}`;
        }
        calls.push(this._chatLogService.createchatforpayment(this.token, {
          father_id:   fatherId,
          message:     msg2,
          type:        'PAYMENT',
          paymentid:   paymentId,
          stepPayment: 2
        }));
      }

    if (changedEtapa3) {
      let msg3 = `EDIT - Has the equipment been tested and quantities confirmed? – ${testedNow?.toUpperCase()}`;
      if (testedNow === 'no' && testedCommentNow) {
        msg3 += ` – ${testedCommentNow}`;
      }
      calls.push(this._chatLogService.createchatforpayment(this.token, {
        father_id:   fatherId,
        message:     msg3,
        type:        'PAYMENT',
        paymentid:   paymentId,
        stepPayment: 3
      }));
    }
  
   

    }
    if (changedNote && currentNote) {
      let notaMsg = `${notePrefix}${currentNote}`;
      const step = this.paymentdata.paymentType === 'PO' ? 5 : 4;
      calls.push(this._chatLogService.createchatforpayment(this.token, {
        father_id: fatherId,
        message: notaMsg,
        type: 'PAYMENT',
        paymentid: paymentId,
        stepPayment: step
      }));
    }
    if (calls.length > 0) {
      from(calls).pipe(
        concatMap(call$ => call$),
        toArray()
      ).subscribe({
        next: () => {
         
        },
        complete: () => {
         
        },
        error: (err) => {
          
        }
      });
    } else {
      
     
    }
    this._pagoService.updatepayment(this.token, payload)
      .pipe(finalize(() => this.submitting = false))
      .subscribe({
        next: (resp: any) => {
          if (resp.status === 'success') {
            Swal.fire('Changes saved successfully!', 'New approval request has been sent. ', 'success');
            this.dialogRef.close(true); 
          } else {
            this.showToast('error', 'Ops Something went wrong.', 2000);
          }
        },
        error: (err) => {
          this.showToast('error', 'Ops Something went wrong.', 2000);
        }
      });

  }
  private cleanNote(msg: string): string {
    if (!msg) return '';
    const regex = /^(EDIT\s*-\s*)?Additional Notes\s*–\s*/i;
    return msg.replace(regex, '').trim();
  }
  
  formatDateForPayload(date: any): string | null {
    if (!date) return null;
    if (typeof date === 'string') return date.substring(0,10);
    if (date instanceof Date) {
      
      return date.toISOString().split('T')[0];
    }
    if (date && date.year && date.month && date.day) {
      return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }
    return null;
  }
  
  /*  */

step1Completed(): boolean {
  if (!this.paymentdata) return false;
  if (!this.paymentdata.paymentType) return false;
  if (this.paymentdata.paymentType === 'PO') {
    return this.bulk.length > 0;
  } else {
    return !!(
      this.paymentdata.CosigmentDetail?.datefrom &&
      this.paymentdata.CosigmentDetail?.dateto
    );
  }
}


step2Valid(): boolean {
  if (!this.paymentdata) return false;
  if (this.paymentdata.paymentType === 'PO') {
    return !!this.paymentdata.equipmentReceived; 
  } else {
    return true; 
  }
}
step2Completed(): boolean {
 
  return this.step2Valid();
}


step3Valid(): boolean {
  if (!this.paymentdata) return false;
  if (this.paymentdata.paymentType === 'PO') {
    return !!this.step3Control.get('tested').value; 
  }
  return true;
}

step3Completed(): boolean {
  return this.step3Valid();
}


step4Valid(): boolean {
  if (!this.paymentdata.requestedAmount) return false;
  if (!this.paymentdata.paymentDueType) return false;
  if (this.paymentdata.paymentDueType === 'SpecificDate') {
    return !!this.paymentdata.paymentDueDate;
  }
  return true;
}
step4Completed(): boolean {
  return this.step4Valid();
}


private buildChecks(md: any): void {
  this.checksArray = [];
  if (!md) return;
  const num = md.numberOfChecks ?? 1;
  for (let i = 1; i <= num; i++) {
    this.checksArray.push({
      idx: i,
      payableTo: md[`checkPayableTo${i}`] ?? '',
      amount: md[`checkAmount${i}`] ?? ''
    });
  }
}


incrementChecksEdit(): void {
  const md = this.paymentdata.methodDetail;
  md.numberOfChecks = (md.numberOfChecks ?? 1) + 1;
  this.buildChecks(md);
}

decrementChecksEdit(): void {
  const md = this.paymentdata.methodDetail;
  md.numberOfChecks = (md.numberOfChecks ?? 1) - 1;
  if (md.numberOfChecks < 1) md.numberOfChecks = 1;
  this.buildChecks(md);
}


setPercentEdit(pct: number): void {
  const total = Number(this.paymentdata.totalAmount) || 0;
  this.paymentdata.requestedAmount = +(total * pct).toFixed(2);
}

  getlistvendor() {
    this._pagoService.getlistcompanies(this.token)
      .subscribe((response: any) => {
        this.companyOptions = response.companies.map(c => ({
          value: c.name,
          name:  c.name
        }));
      }, err => {
        console.error('Error cargando empresas', err);
      });
  }
  onSelectPaymentType(value: string) {
    this.selectedPaymentType = value;
    this.selectedCompany = null;
    this.bulk = [];
  }
  onSelectCompany(company: string) {
    this.selectedCompany = company;
    if (this.paymentdata.paymentType === 'PO') {
      
      this.getlistpo();
    }
  }
  private _originalReceivedCommentSet = false;
  private _originalTestedCommentSet = false;
  private _originalNoteCommentSet = false;

  getComment(paymentId,stepPayment){
  this.loadingComment = true;
  const body = { idpayment: paymentId, stepPayment: stepPayment };
  this._chatLogService.getcommentPayment(this.token, body)
    .subscribe({
      next: (response: any) => {
        this.loadingComment = false;
        if (response?.status === 'success' && response.data && response.data.length) {
          
          const message = response.data[0].message || '';
          const partes = message.split('–');
          if (partes.length >= 3) {
            this.equipmentReceivedComment = partes[2].trim();
            if (!this._originalReceivedCommentSet) {
              this.originalReceivedComment = this.equipmentReceivedComment || '';
              this._originalReceivedCommentSet = true;
            }
          } else {
           
            this.equipmentReceivedComment = message;
          }
        } else {
          this.equipmentReceivedComment = '';
        }
      },
      error: (err) => {
        this.loadingComment = false;
        this.equipmentReceivedComment = '';
        console.error('Error Cargar Comentario de Equipamiento', err);
      }
    });
}


getCommentstep3(paymentId, stepPayment) {
  const body = { idpayment: paymentId, stepPayment: stepPayment };
  this._chatLogService.getcommentPayment(this.token, body)
    .subscribe({
      next: (response: any) => {
        if (response?.status === 'success' && response.data && response.data.length) {
          const message = response.data[0].message || '';
          const partes = message.split('–');
          let comment = '';
          if (partes.length >= 3) {
            comment = partes[2].trim();
          } else {
            comment = message.trim();
          }
          
          if (!comment || comment.toLowerCase() === 'yes') {
            this.testedComment = '';
          } else {
            this.testedComment = comment;
            if (!this._originalTestedCommentSet) {
              this.originalTestedComment = this.testedComment || '';
              this._originalTestedCommentSet = true;
            }
          }
        } else {
          this.testedComment = '';
        }
      },
      error: (err) => {
        this.testedComment = '';
        console.error('Error Cargar Comentario de tested', err);
      }
    });
}


getCommentstep5(paymentId, stepPayment) {
  const body = { idpayment: paymentId, stepPayment: stepPayment };
  this._chatLogService.getcommentPayment(this.token, body)
    .subscribe({
      next: (response: any) => {
        if (response?.status === 'success' && response.data && response.data.length) {
          
          const lastMsg = response.data[0].message || '';

         
          let nota = lastMsg;
          const regex = /^(EDIT\s*-\s*)?Additional Notes\s*–\s*/i;
          nota = nota.replace(regex, '').trim();

          this.notecomment = nota;
          if (!this._originalNoteCommentSet) {
            this.originalNoteComment = nota; 
            this._originalNoteCommentSet = true;
          }
        } else {
          this.notecomment = '';
        }
      },
      error: (err) => {
        this.notecomment = '';
        console.error('Error Cargar Comentario de Nota Adicional', err);
      }
    });
}









  getlistpo( e=null ){
    this.loading = true;
    let data={name:this.selectedCompany,sort:[this.filterrigh], order:this.sortStates}
    this._pagoService.getlistpobycompanies(this.token,data,e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,this.filtros)
    .subscribe((response: any) => {
      if (response.status === 'success') { 
        this.paginaActual = Number(response.page_actual);
        this.itemsPorPagina = String(response.items_per_page);
        this.totalItems = Number(response.total_items_count);
        this.totalPaginas = Number(response.total_pages);
        this.podata.rows = [];
        this.lastRows = response.data;
        for (let row of response.data) {
          this.allRows[row.id] = row;
        }
        for (let element of response.data) {
          const selected_value = this.bulk.includes(element.id.toString());
          const createAt = this.mtds.getFecha(
            new Date(element.po?.createdAt),
            "MM-dd-yyyy"
          );
          this.podata.rows.push(
            [ 
              new Cell(element.id , {
                type: "checkbox",
                selected: selected_value
               
              }),
              new Cell(element.id),
              new Cell(element.po?.po ?? '' ),
              new Cell(element.clientName ?? ''),
              new Cell(element.po.rep ? `${element.po?.rep?.name ?? ''} ${element.po?.rep?.surname ?? ''}`.trim() : ''), 
              new Cell(element.originalTotalCostPo ?? ''),
              new Cell(element.po?.terms ?? ''),
              new Cell(element.manifestStatus ?? ''),
              new Cell(element.testingStatus ?? ''),
              new Cell(createAt),
            ]
          );
        }
        this.loading = false;
      }
    }, err => {
      console.error('Error cargando empresas', err);
      this.loading = false;
    });
  }

  public checksArray: any[] = [];


  getSelectedMethodTabIndex(): number {
    return this.methodTabs.indexOf(this.paymentdata.methodDetail?.methodType || 'CHECK_PICKUP');
  }
  
  
  onMethodTabChange(idx: number) {
    const newMethod = this.methodTabs[idx];
    
    if (this.paymentdata.methodDetail.methodType !== newMethod) {
      
      this.paymentdata.methodDetail = {
        ...this.paymentdata.methodDetail, 
        methodType: newMethod,
        numberOfChecks: this.paymentdata.methodDetail.numberOfChecks || 1
      };
      this.buildChecks(this.paymentdata.methodDetail);
    }
  }

  setWTDOME(value: 'manual' | 'file') {
    this.WTDOME = value;
    
    this.paymentdata.methodDetail.modeform = value === 'manual' ? 1 : 0;
  }
  setWTINT(value: 'manual' | 'file') {
    this.WTINT = value;
    
    this.paymentdata.methodDetail.modeform = value === 'manual' ? 1 : 0;
  }
  setACHDOME(value: 'manual' | 'file') {
    this.ACHDOME = value; 
    
    this.paymentdata.methodDetail.modeform = value === 'manual' ? 1 : 0;
  }


  get consignmentTotal(): string {
    if (this.paymentdata.paymentType === 'CONSIGNMENT') {
     
      let total = 0;
      if (
        this.paymentdata.totalAmount !== undefined &&
        this.paymentdata.totalAmount !== null &&
        !isNaN(Number(this.paymentdata.totalAmount)) &&
        Number(this.paymentdata.totalAmount) > 0
      ) {
        total = Number(this.paymentdata.totalAmount);
      } else if (
        this.paymentdata.requestedAmount !== undefined &&
        this.paymentdata.requestedAmount !== null &&
        !isNaN(Number(this.paymentdata.requestedAmount))
      ) {
        total = Number(this.paymentdata.requestedAmount);
      }
      return total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
 
    return this.bulkTotal;
  }
  private syncBulkDetailsWithSelectedPO() {
   
    if (!this.bulk || this.bulk.length === 0) {
      this.bulkDetails = [];
      this.bulkTotal = "0.00";
      this.poNumbers = [];
      this.paymentdata.items = [];
      return;
    }
  
    this.bulkDetails = this.bulk
      .map(id => {
      
        const row = this.allRows[id];
        if (!row) return null;
        return {
          id: row.id, // PI id
          po: row.po.po,
          amount: Number(row.originalTotalCostPo)
        };
      })
      .filter(Boolean);

    this.poNumbers = this.bulkDetails.map(item => item.po);
  
   
    const sum = this.bulkDetails.reduce((acc, item) => acc + (item.amount || 0), 0);
    this.bulkTotal = sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  
   
    this.paymentdata.items = this.bulkDetails.map(item => {
      const row = this.allRows[item.id];
      return {
        processingInstruction: {
          id: row.id, 
         /*  clientName: row.po.vendor */
        },
        poInfo: {
       /*    id: row.po.id, // ID del PO, ojo si tu row lo tiene */
          po: row.po.po
        },
        originalTotalCostPo: row.originalTotalCostPo,
        requestedAmount: this.paymentdata.requestedAmount
      };
    });
  }
  onBulkChange(newBulk: string[]) {
    
    this.bulk = newBulk;
    this.syncBulkDetailsWithSelectedPO();
  }
  
  methodTabs  = [
    'CHECK_PICKUP',
    'CHECK_MAILED',
    'ACH_DOMESTIC',
    'WT_INTERNATIONAL',
    'WT_DOMESTIC',
    'PAYPAL',
    'CREDIT_CARD'
  ];
  
 
  methodNames = {
    'CHECK_PICKUP': 'Check Pickup',
    'CHECK_MAILED': 'Check Mailed',
    'ACH_DOMESTIC': 'ACH Domestic',
    'WT_INTERNATIONAL': 'Wire Transfer International',
    'WT_DOMESTIC': 'Wire Transfer Domestic',
    'PAYPAL': 'PayPal',
    'CREDIT_CARD': 'Credit Card'
  };
  
  selectedPaymentMethod: string = 'CHECK_PICKUP';
  
  get poNumbersText(): string {
   
    if (!this.bulkDetails || this.bulkDetails.length === 0) return '';
    return this.bulkDetails.map(x => x.po).join(', ');
  }
  
  trackById(index: number, item: any) {
    return item.id;
  }
  private setBulkDetails() {
    if (!this.paymentdata || !this.paymentdata.items) {
      this.bulkDetails = [];
      this.bulkTotal = "0.00";
      return;
    }

    this.bulkDetails = this.paymentdata.items.map(item => ({
      id: item.processingInstruction?.id,
      po: item.poInfo?.po,
      amount: Number(item.originalTotalCostPo) 
    }));
  
   
    if (this.paymentdata.totalAmount !== undefined && this.paymentdata.totalAmount !== null) {
      this.bulkTotal = Number(this.paymentdata.totalAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } else {
      
      const sum = this.bulkDetails.reduce((acc, item) => acc + (item.amount || 0), 0);
      this.bulkTotal = sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
  
/*   private setBulkDetails() {
    if (!this.paymentdata || !this.paymentdata.items) {
      this.bulkDetails = [];
      this.bulkTotal = "0.00";
      return;
    }
   
    this.bulkDetails = this.paymentdata.items.map(item => ({
      id: item.processingInstruction?.id,        
      po: item.poInfo?.po,
      amount: item.requestedAmount !== null && item.requestedAmount !== undefined
        ? Number(item.requestedAmount)
        : Number(item.originalTotalCostPo)
    }));
  
  } */
  public filterrigh = "";
  public sortStates = ""; 
   handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    

   this.getlistpo();
   }
  cleanfilter(){
    this.filtros = [
      null,
      null,
      {
        key: "po",
        title: "PO",
        value: "",
        type: "contains",
        key_type: "po_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "vendor",
        title: "Vendor",
        value: "",
        type: "contains",
        key_type: "vendor_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "rep",
        title: "Rep",
        value: "",
        type: "contains",
        key_type: "rep_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "amount",
        title: "Amount",
        value: "",
        type: "equalto",
        key_type: "amount_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "equalto", name: "Equal To" },
          { value: "notequalto", name: "Not Equal To" },
          { value: "greaterthan", name: "Greater Than" },
          { value: "lessthan", name: "Less Than" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "purchasing",
        title: "Purchasig Terms",
        value: "",
        type: "contains",
        key_type: "purchasing_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "manifest",
        title: "Manifest Status",
        value: "",
        type: "contains",
        key_type: "manifest_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "testing",
        title: "Testing Status",
        value: "",
        type: "contains",
        key_type: "testing_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "date",
        title: "Purchase Date",
        value: "",
        type: "equalto",
        key_type: "date_type",
        type_options:[
          { value: "nofilter", name: "No Filter" },
          { value: "equalto", name: "Equal To" },
          { value: "notequalto", name: "Not Equal To" },
          { value: "greaterthan", name: "Greater Than" },
          { value: "lessthan", name: "Less Than" },
        ],
      },
    ];
  }
  public filtros = [
    null,
    null,
    {
      key: "po",
      title: "PO",
      value: "",
      type: "contains",
      key_type: "po_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "vendor",
      title: "Vendor",
      value: "",
      type: "contains",
      key_type: "vendor_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "rep",
      title: "Rep",
      value: "",
      type: "contains",
      key_type: "rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "amount",
      title: "Amount",
      value: "",
      type: "equalto",
      key_type: "amount_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "equalto", name: "Equal To" },
        { value: "notequalto", name: "Not Equal To" },
        { value: "greaterthan", name: "Greater Than" },
        { value: "lessthan", name: "Less Than" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "purchasing",
      title: "Purchasig Terms",
      value: "",
      type: "contains",
      key_type: "purchasing_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "manifest",
      title: "Manifest Status",
      value: "",
      type: "contains",
      key_type: "manifest_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "testing",
      title: "Testing Status",
      value: "",
      type: "contains",
      key_type: "testing_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "date",
      title: "Purchase Date",
      value: "",
      type: "equalto",
      key_type: "date_type",
      type_options:[
        { value: "nofilter", name: "No Filter" },
        { value: "equalto", name: "Equal To" },
        { value: "notequalto", name: "Not Equal To" },
        { value: "greaterthan", name: "Greater Than" },
        { value: "lessthan", name: "Less Than" },
      ],
    },
  ];
  private lastRows: Array<{
    id: number,
    po: { po: string },
    originalTotalCostPo: number,
    
  }> = [];
  private allRows: { [id: number]: {
    id: number,
    po: { po: string },
    originalTotalCostPo: number
  } } = {};
  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig('popaymentTableEdit', this.options).subscribe(
      r => {
        console.log(r)

      }
    );
  }
  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
}
